import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  SimpleChanges,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaskPipe } from 'ngx-mask';
import Utils from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FundService } from 'src/app/services/fund/fund.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dashboard-fund-approval-assignor',
  templateUrl: './dashboard-fund-approval-assignor.component.html',
  styleUrls: ['./dashboard-fund-approval-assignor.component.scss'],
})
export class DashboardFundApprovalAssignorComponent implements OnInit {
  @Output() onClick = new EventEmitter<MouseEvent>();

  loading = true;
  data;

  canView = false;

  status_dict: Record<string, { label: string; cssClass: string }> = {
    created: { label: 'Em edição', cssClass: 'status-badge-editing' },
    pending: { label: 'Em aprovação', cssClass: 'status-badge-approval' },
    approved: { label: 'Homologado', cssClass: 'status-badge-homologated' },
  };

  columns: TableColumnList<any>[] = [
    {
      name: 'Cedente',
      cell: (row) => `
    <div class="dash-card-item p-0">
        <div class="dash-card-item-initials mr-3">
            <span>${this.getInitials(row.links.register)}</span>
        </div>

        <div class="dash-card-item-content">
            <div class="dash-card-item-content-title">
                ${
                  row.links.register.type === 'PF'
                    ? row.links.register.person.full_name
                    : row.links.register.company.corporate_name
                }
            </div>
            <div class="dash-card-item-content-subtitle">
                ${
                  row.links.register
                    ? this.formatDocument(row.links.register)
                    : ''
                }
            </div>
        </div>
    </div>
        `,
      size: 2,
    },
    {
      name: 'Status',
      cell: (row) => this.renderStatusBadge(row),
    },
    {
      name: 'Criado em',
      cell: (row) =>
        this.formatDate(row.created_at ?? row.links?.register?.created_at),
    },
    {
      name: 'Última atualização',
      cell: (row) =>
        this.formatDate(row.updated_at ?? row.links?.register?.updated_at),
    },
    {
      name: '',
      cell: (row) => this.renderViewAction(row),
    },
  ];
  //   data: Partial<ShareholderListValues>[] = [];

  constructor(
    public fundService: FundService,
    private maskPipe: MaskPipe,
    private router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private authService: AuthService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.canView = this.authService.verifyPermission(
      'de_can_view_fund_assignor_details',
    );

    this.columns = [
      {
        name: 'Cedente',
        cell: (row) => `
          <div class="dash-card-item p-0">
              <div class="dash-card-item-initials mr-3">
                  <span>${this.getInitials(row.links.register)}</span>
              </div>
      
              <div class="dash-card-item-content">
                  <div class="dash-card-item-content-title">
                      ${
                        row.links.register.type === 'PF'
                          ? row.links.register.person.full_name
                          : row.links.register.company.corporate_name
                      }
                  </div>
                  <div class="dash-card-item-content-subtitle">
                      ${
                        row.links.register
                          ? this.formatDocument(row.links.register)
                          : ''
                      }
                  </div>
              </div>
          </div>
              `,
        size: 2,
      },
      {
        name: 'Status',
        cell: (row) => this.renderStatusBadge(row),
      },
      {
        name: 'Criado em',
        cell: (row) =>
          this.formatDate(row.created_at ?? row.links?.register?.created_at),
      },
      {
        name: 'Última atualização',
        cell: (row) =>
          this.formatDate(row.updated_at ?? row.links?.register?.updated_at),
      },
      {
        name: '',
        cell: (row) => this.renderViewAction(row),
      },
    ];

    if (this.fundService.fundData.assignors) {
      this.data = this.fundService.fundData.assignors;
      this.loading = false;
      setTimeout(() => this.setHandlers());
    } else {
      this.getFundData();
    }
  }

  //   ngAfterViewInit() {
  //     this.setHandlers();
  //   }

  //   ngOnChanges(changes: SimpleChanges) {
  //     setTimeout(() => {
  //       this.setHandlers();
  //     }, 1000);
  //   }

  setHandlers() {
    const visualizers = this.elementRef.nativeElement.querySelectorAll(
      '.assignor-visualizer:not(.assignor-visualizer-disabled)',
    );

    visualizers.forEach((button: HTMLElement) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', (event) => {
        const el = event.currentTarget as HTMLElement;
        const idClass = Array.from(el.classList).find((className) =>
          className.startsWith('row-'),
        );
        const id = idClass?.replace('row-', '');

        const finded = this.data.find((item: any) => {
          return item?.links?.register?.id != null && String(item.links.register.id) === id;
        });

        if (finded && !this.isAssignorInEditing(finded)) {
          this.handleRedirect(finded);
        }
      });
    });
  }

  isAssignorInEditing(row: any): boolean {
    const status = (row?.status ?? row?.links?.register?.status ?? '')
      .toString()
      .toLowerCase();
    const approvalStatus = (row?.links?.register?.approval_status ?? '')
      .toString()
      .toLowerCase();

    return (
      status === 'created' ||
      status === 'em_edicao' ||
      status === 'em edição' ||
      status === 'em edicao' ||
      approvalStatus === 'em_edicao'
    );
  }

  renderViewAction(row: any) {
    if (!this.canView) return '';

    const id = row?.links?.register?.id;
    const blocked = this.isAssignorInEditing(row);
    const title = blocked
      ? 'Indisponível para registros em edição'
      : 'Visualizar';

    return `<div class="d-flex align-items-center icon-container">
      <div class="assignor-visualizer${blocked ? ' assignor-visualizer-disabled' : ''} row-${id}"
        title="${title}" role="button" aria-disabled="${blocked}">
        <img src="assets/images/icon-eye.svg" alt="" />
      </div>
    </div>`;
  }

  handleRedirect(assignor: any) {
    this.router.navigateByUrl(
      '/app/details/assignor/' + assignor.links.register.id,
    );
  }

  formatDate(date?: string | null) {
    if (!date) return '-';
    const day = date.split('T')[0]?.split('-').reverse().join('/');
    return day || '-';
  }

  getAssignorStatus(row: any) {
    const raw = (row?.status ?? row?.links?.register?.status ?? '')
      .toString()
      .toLowerCase();

    return (
      this.status_dict[raw] ?? {
        label: raw || '-',
        cssClass: 'status-badge-editing',
      }
    );
  }

  renderStatusBadge(row: any) {
    const status = this.getAssignorStatus(row);
    return `<span class="status-badge ${status.cssClass}">${status.label}</span>`;
  }

  formatDocument(user: any) {
    if (user.type === 'PF') {
      return this.maskPipe.transform(
        user.person.document.number,
        '000.000.000-00',
      );
    } else {
      return Utils.formatDocumentForDisplay(user.company.document.number);
    }
  }

  getInitials(user: any) {
    if (user.type === 'PF') {
      const full_name = user.person.full_name;

      return Utils.getInitials(full_name);
    } else {
      const corporate_name = user.company.corporate_name;

      return Utils.getInitials(corporate_name);
    }
  }

  async getFundData() {
    try {
      const data = await this.api.get({
        route: 'api/v2/approvals/version/',
        params: {
          fund: this.route.snapshot.params.id,
          tab: 'assignors',
        },
        token: true,
      });

      const fund = { ...data };

      if (fund[0].fund && fund[0].fund.length === 0) {
        this.loading = false;
        return;
      }

      this.data = fund[0].fund[0].links;

      this.fundService.fundData = {
        ...this.fundService.fundData,
        assignors: fund[0].fund[0].links,
      };

      setTimeout(() => {
        this.setHandlers();
      }, 500);
    } catch (error) {
      this.toast.show('error', 'Erro', 'Erro ao carregar cedentes: ' + error);
    }

    this.loading = false;
  }
}
